import { ReactComponent as BlackStarsIcon } from 'assets/icons/BlackStars.svg';
import { styled } from '@mui/material/styles';
import { Box, Skeleton, Typography } from '@mui/material';

type ArticleAttachmentSummaryIndicatorProps = {
  showAttachmentSummaryIndicatorSkeleton?: boolean;
};

function ArticleAttachmentSummaryIndicator({
  showAttachmentSummaryIndicatorSkeleton,
}: ArticleAttachmentSummaryIndicatorProps) {
  return (
    <AttachmentSummaryIndicator
      sx={{ width: showAttachmentSummaryIndicatorSkeleton ? '100%' : 'fit-content' }}
    >
      <Arrow />
      <Box mr={1}>
        <BlackStarsIcon width={20} height={20} />
      </Box>
      <Box flex={1}>
        {showAttachmentSummaryIndicatorSkeleton ? (
          <Skeleton
            animation="wave"
            variant="text"
            width="100%"
            height={20}
            sx={(theme) => ({
              my: 1,
              backgroundColor: theme.palette.custom.skelton1,
              mt: 0,
              '&::after': {
                background: `linear-gradient(
                  90deg,
                  transparent,
                  rgb(143 143 143 / 80%),
                  transparent
                )`,
              },
            })}
          />
        ) : (
          <Typography>Attachment contains relevant information to your search.</Typography>
        )}
      </Box>
    </AttachmentSummaryIndicator>
  );
}

const AttachmentSummaryIndicator = styled(Box, { label: 'AttachmentSummaryIndicator' })(
  ({ theme }) => ({
    position: 'relative',
    padding: '12px 16px',
    color: theme.palette.custom.black,
    fontWeight: 400,
    fontSize: 16,
    whiteSpace: 'pre-wrap',
    backgroundColor: theme.palette.custom.tropicalBlue,
    margin: '12px 0 8px',
    borderRadius: '0 4px 4px 4px',
    display: 'flex',
  }),
);

const Arrow = styled(Box, { label: 'Arrow' })(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'translateY(-100%)',
  borderWidth: 6,
  borderStyle: 'solid',
  borderColor: `transparent transparent ${theme.palette.custom.tropicalBlue} ${theme.palette.custom.tropicalBlue}`,
  borderRadius: '4px 4px 0 0',
}));

export default ArticleAttachmentSummaryIndicator;
